import styled from 'styled-components';
const StyledInfoContainer = styled.div``;

export default StyledInfoContainer;

export const Wrapper = styled.div`
    padding: 20px;
    background-color: #ffffff;
`;
